import React from "react";

type SectionTitleProps = {
  title: string;
  icon?: React.ReactNode;
  className?: string;
};

const SectionTitle = (props: SectionTitleProps) => {
  const { title, className } = props;
  return (
    <div className={`flex flex-col items-center gap-2 ${className || ""}`}>
      <h2 className="text-2xl font-semibold">{title}</h2>
      <hr className="border-primary w-20 border-2 rounded-full" />
    </div>
  );
};

export default SectionTitle;
